import { useContext } from "react";
import { CompanyPolicyContext } from "../../../routes/CompanyPolicyProtectedRoute";
import { IPermissionItem } from "@lhd/types";
import { useGetPermissionsEachPage } from "@lhd/hooks";
import { ROUTES } from "@lhd/constants";
import { buildCompanyPolicyEditPermission } from "./permission";

const useEdit = () => {
  const { data } = useContext(CompanyPolicyContext);
  const permissionsEachPage = useGetPermissionsEachPage();

  const permission: IPermissionItem = buildCompanyPolicyEditPermission(
    data,
    permissionsEachPage[ROUTES.COMPANY_POLICIES],
  );

  return {
    permissionItem: permission,
  };
};

export type Props = ReturnType<typeof useEdit>;

export default useEdit;
